import { render, staticRenderFns } from "./ProgramMinorSelectbox.vue?vue&type=template&id=7f606ed5"
import script from "./ProgramMinorSelectbox.vue?vue&type=script&lang=js"
export * from "./ProgramMinorSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports